import { AppSetting } from '../AppSetting';
import { AppSettingApi } from '../AppSettingApi';
import { BaseService } from '../Service/BaseService';
import { BaseWebApiDAO } from './BaseWebApiDAO';
import { MailTemplateCategoryDTOInterface } from '../DTO/MailTemplateCategoryDTOInterface';

export class MessageTemplateCategoryDAO extends BaseWebApiDAO {

	/**
	 * constructor
	 */
	constructor(svc: BaseService) {
		super(svc);
	}

	public async getList(): Promise<MailTemplateCategoryDTOInterface[]> {

		// リクエスト作成
		const request = {
			t: this.token
		};

		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_CATEGORY_LIST, request);
		return res;

	}

	public async getMailTemplateCategory(id: number): Promise<any> {

		// デバッグモードならダミーを返す
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			id
		};

		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_CATEGORY_DETAIL, request);
		return res;

	}


	public async create(name: string): Promise<any> {

		// デバッグモードならダミーを返す
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			name
		};

		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_CATEGORY_CREATE, request);
		return res;

	}


	public async update(id: number, name: string): Promise<any> {

		// デバッグモードならダミーを返す
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			id,
			name
		};

		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_CATEGORY_UPDATE, request);
		return res;

	}

	public async delete(id: number): Promise<any> {

		// デバッグモードならダミーを返す
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			id
		};

		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_CATEGORY_DELETE, request);
		return res;

	}

}
